(function () {
  'use strict';

  function enhanceIndex(root) {
    var dataNode = document.getElementById('wtpb-remembrance-index-data');
    var index = (root || document).querySelector('.wtpb-remembrance__index-grid');
    if (!dataNode || !index) return;

    var memorials;
    try {
      memorials = JSON.parse(dataNode.textContent);
    } catch (error) {
      return;
    }

    memorials.forEach(function (memorial) {
      var link = index.querySelector('a[href="#' + memorial.id + '"]');
      if (!link || link.classList.contains('wtpb-remembrance-card')) return;

      var image = document.createElement('img');
      image.className = 'wtpb-remembrance-card__image';
      image.src = memorial.image;
      image.alt = memorial.alt;
      image.loading = 'lazy';
      image.width = 56;
      image.height = 60;

      var copy = document.createElement('div');
      copy.className = 'wtpb-remembrance-card__copy';
      while (link.firstChild) copy.appendChild(link.firstChild);

      link.appendChild(image);
      link.appendChild(copy);
      link.classList.add('wtpb-remembrance-card');
      link.setAttribute('data-wtpb-remembrance-card', memorial.id);
    });
  }

  function init() {
    enhanceIndex(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    enhanceIndex(event.target);
  });

  function pawMarkup(number) {
    return '<svg class="wtpb-remembrance__trail-paw wtpb-remembrance__trail-paw--' + number + '" viewBox="0 0 28 28" aria-hidden="true">' +
      '<ellipse cx="14" cy="18" rx="7.2" ry="6.4" fill="currentColor"/>' +
      '<ellipse cx="6.2" cy="11" rx="3.1" ry="4.2" transform="rotate(-25 6.2 11)" fill="currentColor"/>' +
      '<ellipse cx="11.4" cy="7" rx="3" ry="4.1" transform="rotate(-8 11.4 7)" fill="currentColor"/>' +
      '<ellipse cx="17.4" cy="7" rx="3" ry="4.1" transform="rotate(8 17.4 7)" fill="currentColor"/>' +
      '<ellipse cx="22.2" cy="11.2" rx="3.1" ry="4.2" transform="rotate(25 22.2 11.2)" fill="currentColor"/>' +
      '</svg>';
  }

  function dogMarkup(pose) {
    if (pose === 'dig') {
      return '<svg class="wtpb-remembrance__trail-dog" viewBox="0 0 140 90" aria-hidden="true">' +
        '<g fill="currentColor"><ellipse cx="78" cy="36" rx="30" ry="17"/><circle cx="43" cy="51" r="14"/>' +
        '<ellipse cx="31" cy="58" rx="13" ry="7"/><path d="M39 37 29 23 47 31Z"/>' +
        '<path d="M103 34c16-17 28-10 24-2-4 7-13 3-19 12Z"/></g>' +
        '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="7">' +
        '<path d="M58 48 39 72"/><path d="M69 50 52 77"/><path d="M92 49 97 72"/></g>' +
        '<g fill="#b88142" opacity=".72"><circle cx="22" cy="76" r="4"/><circle cx="34" cy="80" r="3"/><circle cx="47" cy="82" r="2.5"/></g>' +
        '<circle cx="38" cy="49" r="2" fill="#fffaf1"/></svg>';
    }

    return '<svg class="wtpb-remembrance__trail-dog" viewBox="0 0 140 90" aria-hidden="true">' +
      '<g fill="currentColor"><ellipse cx="80" cy="39" rx="30" ry="17"/><circle cx="44" cy="55" r="14"/>' +
      '<ellipse cx="30" cy="64" rx="14" ry="7"/><path d="M42 41 32 25 49 34Z"/>' +
      '<path d="M106 37c14-18 28-12 25-4-3 8-14 5-20 14Z"/></g>' +
      '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="7">' +
      '<path d="M63 51 60 76"/><path d="M82 53 84 77"/><path d="M98 51 104 75"/></g>' +
      '<circle cx="38" cy="54" r="2" fill="#fffaf1"/><circle cx="17" cy="68" r="2.5" fill="#b88142" opacity=".7"/></svg>';
  }

  function enhanceTrailScenes(root) {
    var trails = (root || document).querySelectorAll('#remembrance-top .wtpb-remembrance__trail');

    Array.prototype.forEach.call(trails, function (trail, index) {
      if (trail.querySelector('.wtpb-remembrance__trail-scene')) return;

      var copy = document.createElement('span');
      copy.className = 'wtpb-remembrance__trail-copy';
      while (trail.firstChild) copy.appendChild(trail.firstChild);

      var scene = document.createElement('span');
      var side = index % 2 === 0 ? 'right' : 'left';
      var pose = index % 2 === 0 ? 'sniff' : 'dig';
      scene.className = 'wtpb-remembrance__trail-scene wtpb-remembrance__trail-scene--' + pose;
      scene.setAttribute('aria-hidden', 'true');
      scene.innerHTML = pawMarkup(1) + pawMarkup(2) + pawMarkup(3) + dogMarkup(pose);

      trail.classList.add('wtpb-remembrance__trail--' + side, 'wtpb-remembrance__trail--scene-' + (index + 1));
      trail.appendChild(copy);
      trail.appendChild(scene);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      enhanceTrailScenes(document);
    });
  } else {
    enhanceTrailScenes(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    enhanceTrailScenes(event.target);
  });
}());